import { createDom, format } from 'xgplayer/src/utils/util'
import '../style/controls/poster.scss'

let s_poster = function() {
  let player = this
  let root = player.root

  let poster = createDom('xg-poster', '', {}, 'xgplayer-poster')

  if (player.config.poster) {
    poster.style.backgroundImage = `url(${player.config.poster})`
  }

  root.appendChild(poster)

  // 添加预览视频总时长
  let onTimeChange = function() {
    if (player.duration) {
      poster.innerHTML = `<div class="video-preview-duration">${format(player.duration)}</div>`
    }
  }

  player.on('durationchange', onTimeChange)

  player.once('destroy', () => {
    player.off('durationchange', onTimeChange)
  })
}

export default {
  name: 's_poster',
  method: s_poster
}
